module.exports = __webpack_public_path__ + "a6054a5ff596f6c8b503d388de2f5b4b.svg";